import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Header";

export function WhatsAppButton() {
  const { config } = useApp();
  const num = (config.whatsapp_number || "").replace(/\D/g, "");
  if (!num) return null;
  return (
    <a href={`https://wa.me/${num}`} target="_blank" rel="noreferrer" data-testid="whatsapp-float-btn" aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-2xl bg-[#8C4F27] text-white grid place-items-center shadow-lg hover:-translate-y-1 transition-transform">
      <MessageCircle size={26} />
    </a>
  );
}

export default function Footer() {
  const { t, config, site } = useApp();
  const socials = (site?.socials || []).filter((x) => x.url);
  return (
    <footer className="bg-[#3B220C] text-white/80 mt-24 relative grain" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-16 grid gap-10 md:grid-cols-4 relative z-10">
        <div className="md:col-span-2 space-y-4">
          <Logo light />
          <p className="max-w-sm text-sm leading-relaxed">Rugged Soul, Refined Hands</p>
          <p className="text-xs font-mono text-white/50">{config.store_address}</p>
          {socials.length > 0 && (
            <div className="pt-2 space-y-2" data-testid="footer-socials">
              <p className="font-mono text-xs tracking-[0.2em] text-[#C47A37]">{t("follow_us")}</p>
              <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
                {socials.map((x, i) => <a key={i} href={x.url} target="_blank" rel="noreferrer" className="hover:text-white underline-offset-4 hover:underline" data-testid={`footer-social-${i}`}>{x.label}</a>)}
              </div>
            </div>
          )}
        </div>
        <div className="space-y-3 text-sm">
          <p className="font-mono text-xs tracking-[0.2em] text-[#C47A37]">SHOP</p>
          <Link to="/shop?type=physical" className="block hover:text-white">{t("physical")}</Link>
          <Link to="/shop?type=digital" className="block hover:text-white">{t("digital")}</Link>
          <Link to="/shop?type=course,workshop" className="block hover:text-white">{t("academy")}</Link>
        </div>
        <div className="space-y-3 text-sm">
          <p className="font-mono text-xs tracking-[0.2em] text-[#C47A37]">CRAFTENDEMIC</p>
          <Link to="/journal" className="block hover:text-white">{t("journal")}</Link>
          <Link to="/about" className="block hover:text-white">{t("about")}</Link>
          <Link to="/warranty" className="block hover:text-white" data-testid="footer-warranty-link">{t("check_warranty")}</Link>
          <Link to="/account" className="block hover:text-white">{t("account")}</Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40 relative z-10">© {new Date().getFullYear()} Craftendemic</div>
    </footer>
  );
}
